export * from './bbox';
export * from './canvas';
export * from './create';
export * from './guards';
export * from './spatial';
export * from './wkt';

/**
 * Use when a narrowed type is required.
 */
export function to2DPosition(position: GeoJSON.Position): [number, number] {
  return [position[0], position[1]];
}
